<template>
    <div class="custmize-test" ref="infoBox" >
        <div class="card-sub" >
            <div
                ref="refQuestionType"
                class="card-block-pattern"
                :style="{ height: finalpattern + `px` }"
                
            >
                <!-- {{questionsList}} -->
                <!-- {{this.stepOneData.selectedSubjects}} -->
                <v-card v-for="(que, i) in questionsList" :key="i"  >
                    <v-row>
                        <div class="row-block-20">
                            <v-col cols="12" sm="5">
                                <div class="test-name-block">
                                    <div class="ts-label">Question Types:</div>
                                    <div class="ts-field">
                                        <v-select
                                            v-model="que.questionType"
                                            :items="getQuestionTypes(que)"
                                            @change="checkQuestionType(que,i)"
                                            class
                                            dense
                                            hide-details
                                            filled
                                        ></v-select>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <div class="test-name-block">
                                    <div class="ts-label-50">
                                        Questions/Subject:
                                    </div>
                                    <div class="ts-field-50">
                                        <v-text-field
                                            v-model="que.numberOfQuestion"
                                            min="1"
                                            type="number"
                                            @keydown.space.prevent
                                            @keypress="
                                                allowedOnlyNumber($event, true)
                                            "
                                            @input="
                                                que.noOfMandatoryQuestions =
                                                    que.numberOfQuestion
                                            "
                                            dense
                                            hide-details
                                        ></v-text-field>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="4" class="MandatoryQuestions">
                                <div
                                    class="test-name-block"
                                    v-if="
                                        que.questionType.id !=
                                            QUE_TYPES.COMPREHENSION &&
                                            que.questionType.id != QUE_TYPES.TC
                                    "
                                >
                                    <div class="ts-label-50">
                                        Mandatory Questions:
                                    </div>
                                    <div class="ts-field-50">
                                        <v-text-field
                                            v-model="que.noOfMandatoryQuestions"
                                            type="number"
                                            @keydown.space.prevent
                                            @keypress="
                                                allowedOnlyNumber($event, true)
                                            "
                                            min="1"
                                            dense
                                            hide-details
                                        ></v-text-field>
                                    </div>
                                   

                                </div>
                                <div
                                    v-if="
                                        Number(que.numberOfQuestion) >
                                            Number(que.noOfMandatoryQuestions)
                                    "
                                    class="test-name-block radio-MandatoryQuestions"
                                >
                                    <!-- <div class="ts-label-50">Select Subtype:</div> -->
                                    <div
                                        class="private-radio create-question-radio-group"
                                    >
                                        <div
                                            class="create-question-radio"
                                            v-for="(sType,
                                            index) in mandatoryType"
                                            :key="index"
                                        >
                                            <input
                                                type="radio"
                                                name="allMandatory"
                                                id="allMandatory"
                                                v-model="que.allow_all = sType.value"
                                                :value="sType.value"
                                                color="red"
                                            />
                                            <i
                                                v-if="
                                                    que.allow_all == sType.value
                                                "
                                                aria-hidden="true"
                                                class="v-icon notranslate mdi mdi-radiobox-marked theme--light red--text"
                                            ></i>
                                            <i
                                                v-else
                                                aria-hidden="true"
                                                class="v-icon notranslate mdi mdi-radiobox-blank theme--light"
                                            ></i>
                                            <label :for="sType.value">{{
                                                sType.label.replace(
                                                    "#mandatoryQuestions",
                                                    que.noOfMandatoryQuestions
                                                )
                                            }}</label>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </div>
                        <div class="row-block-20">
                            <v-col cols="12" sm="5">
                                <div class="test-name-block">
                                    <div class="ts-label-50">
                                        Marking Scheme: Correct Response:
                                    </div>
                                    <div class="ts-field-50">
                                        <v-text-field
                                            v-model="que.correctMarkingSchema"
                                            type="number"
                                            @keydown.space.prevent
                                            @keypress="
                                                allowedOnlyNumber($event, true)
                                            "
                                            min="1"
                                            dense
                                            hide-details
                                        ></v-text-field>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <div class="test-name-block">
                                    <div class="ts-label-50">
                                        Incorrect Response:
                                    </div>
                                    <div class="ts-field-50">
                                        <v-text-field
                                            v-model="que.inCorrectMarkingSchema"
                                            type="number"
                                            max="0"
                                            pattern="[0-9]+([\.,][0-9]+)?"
                                            dense
                                            hide-details
                                        ></v-text-field>
                                    </div>
                                    
                                </div>
                                 
                            </v-col>
                            <v-col cols="12" sm="3" class="delete-icon-pos">
                                <div
                                    v-if="showPartialMarking(que)"
                                    class="check-cust"
                                >
                                    <v-checkbox
                                        v-model="que.partialMarking"
                                        label="Partial Marking"
                                        dense
                                        hide-details
                                    ></v-checkbox>
                                </div>
                                <div  class="deleteicon delete-icons">
                                       <v-btn
                                        class="cust-btn"
                                        @click="removeType(i)"
                                        color="primary"
                                        >
                                        <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </div>
                            </v-col>
                        </div>
                    </v-row>
                    <div>
                        <div
                            v-if="
                                que.questionType.id ===
                                    QUE_TYPES.COMPREHENSION ||
                                    que.questionType.id === QUE_TYPES.TC
                            "
                            class="check-cust"
                        >
                            <div class="ts-label-50">Select Subtype:</div>
                            <div
                                class="private-radio create-question-radio-group"
                            >
                                <div
                                    class="create-question-radio"
                                    v-for="sType in que.subTypes"
                                    :key="sType.id"
                                >
                                    <input
                                        type="radio"
                                        :id="sType.id"
                                        :name="sType.id"
                                        v-model="que.selectedSubType"
                                        :value="sType.id"
                                        color="red"
                                    />
                                    <i
                                        v-if="que.selectedSubType == sType.id"
                                        aria-hidden="true"
                                        class="v-icon notranslate mdi mdi-radiobox-marked theme--light red--text"
                                    ></i>
                                    <i
                                        v-else
                                        aria-hidden="true"
                                        class="v-icon notranslate mdi mdi-radiobox-blank theme--light"
                                    ></i>
                                    <label @click="questionsList[i].selectedSubType=sType.id">{{
                                        sType.value
                                    }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>
        <div class="footer-btn-test">
            <div class="add-remove-sub">
                <div
                    v-if="shouldShowAddQuestionType"
                    @click="addNewQuestion"
                    class="circle-icon"
                >
                    <v-icon>mdi-plus-circle</v-icon>
                    <span>Add Question Type</span>
                </div>
                <div class="circle-icon" @click="openDialog">
                    <div v-if="isInstructionsAdded">
                        <v-icon>mdi-pencil-circle</v-icon>

                        <span>Edit Instructions</span>
                    </div>
                    <div v-else>
                        <v-icon>mdi-plus-circle</v-icon>

                        <span>Add Instructions(Optional)</span>
                    </div>
                </div>
            </div>
            <div class="next-btn-footer">
                <v-btn
                    class="right-btn cust-btn min-100"
                    color="primary"
                    @click="
                        onBackClick({
                            questionsList,
                            instructions,
                        })
                    "
                    >Back</v-btn
                >
                <v-btn
                    class="right-btn cust-btn min-100 leftspacing-15"
                    color="primary"
                    @click="questionDetailsDialog()"
                    >Next</v-btn
                >
                <!-- <v-btn class="right-btn cust-btn min-150" color="primary" @click="AddQuestionDialog()">Next</v-btn> -->
            </div>
        </div>
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="{ instructions, stepOneData, persistent, questionTypes:questionTypes2}"
            :onCustomizeClick="onCustom"
        />
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import constants from "../../../../utils/constants";

export default {
    name: "PatternI",
    props: ["onBackClick", "data", "stepOneData", "onCustomizeClick"],
    mounted() {
        this.matchHeight();
        this.requestGetRefData();
        if (this.data) {
            this.instructions = this.data.instructions;
            this.questionsList = this.data.questionsList;
        } else {
            this.addNewQuestion();
        }
        this.getChaptersForAllSubjects();
    },
    data() {
        return {
            shouldScroll: false,
            heightblock: null,
            finalpattern: null,
            dialog: false,
            status: false,
            questionTypes: [],
            questionsList: [],
            questions: [],
            instructions: null,
            modalwidth: null,
            cComponent:
                "components/coordinator/Tests/CustomizedTests/AddInstructions",
            persistent: false,
            selectedQuestionType: 0,
            subjectChapterId: {},
            questionTypes2:[],
			mandatoryType: [
                {
                    label: "Allow only #mandatoryQuestions.",
                    value: 0,
                },
                // {
                //     label: "Evaluate Best #mandatoryQuestions.",
                //     value: 1,
                // },
            ],
        };
    },
    computed: {
        isInstructionsAdded() {
            if (
                !this.instructions ||
                this.extractContent(this.instructions, true).trim() === ""
            ) {
                return false;
            } else {
                return true;
            }
        },
        shouldShowAddQuestionType() {
            return this.getQuestionTypes().length !== 0;
        },
    },
    updated() {
        if (this.shouldScroll) {
            this.scrollToEnd();
            this.shouldScroll = false;
        }
    },
    methods: {
        ...mapActions({
            getRefData: "utilStore/getRefData",
            getSubTypeList: "utilStore/getSubTypeList",
            setQuestions: "questionStore/setQuestions",
            setQuestionsTypeList: "questionStore/setQuestionsTypeList",
            getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
        }),
        onCustom(data) {
            let questiondata = {
                data,
                questionsList: this.questionsList,
                instructions: this.instructions,
                persistent: this.persistent,
                questionTypes: this.questionTypes2,
            };
            this.onCustomizeClick(questiondata);
        },
        showPartialMarking(que) {
            if (
                que.questionType.id === this.QUE_TYPES.MULTIPLE_CORRECT ||
                (que.questionType.id === this.QUE_TYPES.COMPREHENSION &&
                    que.selectedSubType &&
                    (que.selectedSubType ==
                        this.QUE_TYPES.COMPREHENSION_2Q_MA ||
                        que.selectedSubType ==
                            this.QUE_TYPES.COMPREHENSION_3Q_MA))
            ) {
                return true;
            }
            return false;
        },
        getChaptersForAllSubjects() {
            let subjectIds = this.stepOneData.selectedSubjects.map(
                (subject) =>this.getSubjectId(subject)
            );
            let reqData = {
                level: 3,
                parent_ids: subjectIds,
            };
            this.$root.showLoader = true;

            this.getDataTreeWithLevel(reqData)
                .then((response) => {
                    this.$root.showLoader = false;
                    this.stepOneData.selectedSubjects.map((subject) => {
                        let sub = response.find((s) => s.parent == subject.id || s.sub_subject === subject.code);
                        this.subjectChapterId[subject.id] = {
                            chapterId: sub.id,
                        };
                    });
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        questionDetailsDialog() {
            let questionNo = 1;
            let questionTypeList = [];
            if (this.validate()) {
                if (this.questionsList && this.questionsList.length) {
                    if (this.stepOneData && this.stepOneData.selectedSubjects) {
                        this.questions = [];
                        let currentSubjectId =
                            this.stepOneData.selectedSubjects &&
                            this.stepOneData.selectedSubjects[0]
                                ? this.stepOneData.selectedSubjects[0].id
                                : 0;
                        let subIndex = 0;
                        let chapterId = 0;
                        this.stepOneData.selectedSubjects.map((subject) => {
                            chapterId = this.subjectChapterId[subject.id]
                                ? this.subjectChapterId[subject.id].chapterId
                                : 0;
                            if (currentSubjectId != subject.id) {
                                currentSubjectId = subject.id;
                                ++subIndex;
                            }
                            this.questionsList.map((qType) => {
                                let quesType = _.cloneDeep(qType);
                                quesType.subject = subject;
                                quesType.subIndex = subIndex;
                                quesType.chapterId = chapterId;
                                questionTypeList.push(quesType);
                            });
                        });
                    }
                }
                this.setQuestionsTypeList(questionTypeList);
                // this.setQuestions(this.questions);

                this.persistent = true;
                this.cComponent =
                    "components/coordinator/Tests/CustomizedTests/customizedTestsSubPopup";
                this.modalwidth = "1000px";
                this.status = true;
            }
        },
        getSubTypes(que) {
            let postData = {
                parent_id: que.questionType.id,
            };
            this.getSubTypeList(postData)
                .then((response) => {
                    let list=[]
                    response.map((x) => {
                        let canAdd = true;
                        this.questionsList.map((xx) => {
                            if (xx.selectedSubType == x.id) {
                                canAdd = false;
                            }
                        });
                        if (canAdd) {
                            list.push(x);
                        }
                    });
                    if (list.length==1) {
                        que.isRemovedComprehension=true
                    }else {
                        que.isRemovedComprehension=false
                    }
                    this.$set(que, "subTypes", list);
                    this.$set(que, "selectedSubType", list[0].id);
                })
                .catch((err) => {});
        },
        checkQuestionType(que,i) {
			if (this.questionsList[i] && this.questionsList[i].subTypes && this.questionsList[i].selectedSubType) {
				delete this.questionsList[i].subTypes
				delete this.questionsList[i].selectedSubType
			}
			if (
                que.questionType.id === this.QUE_TYPES.COMPREHENSION ||
                que.questionType.id === this.QUE_TYPES.TC
            ) {
                this.getSubTypes(que);
            }
        },
        getQuestionTypes(que) {
            console.log('asdasdasd', que)
            let list = [],i=0;
            this.questionTypes.map((x) => {
                console.log('xx', x)
                let canAdd = true;
                this.questionsList.map((xx,j) => {
                    
                    if (que != xx && xx.questionType.id == x.value.id && x.value.id != 7) {
                        canAdd = false;
                    }
                    if (que!=xx && xx.questionType.id == x.value.id  && x.value.id == 7) {
                        i++
                    }
                    if (i&&i>5&& x.value.id == 7) {
                        canAdd=false;
                    }
                });
                if (canAdd) {
                    list.push(x);
                }
            });
              const selectedTargetExam = localStorage.getItem("selectedTarget") ? parseInt(localStorage.getItem("selectedTarget")) : null;
            if(selectedTargetExam === constants.TARGET_EXAMS.EAMCET || selectedTargetExam === constants.TARGET_EXAMS.KCET || selectedTargetExam === constants.TARGET_EXAMS.MHCET || selectedTargetExam === constants.TARGET_EXAMS.NEET || selectedTargetExam === constants.TARGET_EXAMS.OTHERS || selectedTargetExam === constants.TARGET_EXAMS.BITSAT || selectedTargetExam === constants.TARGET_EXAMS.VITEEE || selectedTargetExam === constants.TARGET_EXAMS.SRMJEE){
                list = list.filter( xx => xx.value.id ===  constants.QUE_TYPES.SINGLE_CORRECT )
               
            }
             if(selectedTargetExam === constants.TARGET_EXAMS.JEE_MAIN){
                list = list.filter( xx => xx.value.id ===  constants.QUE_TYPES.SINGLE_CORRECT || xx.value.id ===  constants.QUE_TYPES.SUBJECTIVEINTEGER )
               
            }

              if(selectedTargetExam === constants.TARGET_EXAMS.JEE_ADVANCED){
                list = list.filter( xx => xx.value.id !==  constants.QUE_TYPES.SINGLE_CORRECT_SEC2  )
               
            }
            console.log('asdasd', list)
            return list;
        },
        matchHeight() {
            this.heightblock = this.$refs.infoBox.clientHeight;
            this.finalpattern = this.heightblock - 60;
        },
        scrollToEnd() {
            var content = this.$refs.refQuestionType;
            content.scrollTop = content.scrollHeight;
        },
        addNewQuestion() {
            this.questionsList.push({
                questionType: {},
                numberOfQuestion: 0,
                noOfMandatoryQuestions: 0,
                correctMarkingSchema: 0,
                inCorrectMarkingSchema: 0,
                partialMarking: false,
            });
            this.shouldScroll = true;
        },
        onClose(data) {
            this.status = data.status;
            if (!data.fromAlertBox && data && (data.instructions || data.instructions=="")) {
                this.instructions = data.instructions;
            }
        },
        openDialog() {
            this.cComponent =
                "components/coordinator/Tests/CustomizedTests/AddInstructions";
            this.modalwidth = "1000px";
            this.status = true;
            this.persistent = false;
        },
        requestGetRefData() {
            let reqData = { keys: ["QUESTION_TYPE"] };
            this.getRefData(reqData)
                .then((response) => {
                    this.loading = false;
                    this.questionTypes2 = response.QUESTION_TYPE.map((x) => {
                        let c = {};
                        c.text = x.value;
                        c.value = { id: x.id, title: x.value };
                        c.checked = false;
                        return c;
                    });
                    this.questionTypes = response.QUESTION_TYPE.filter(
                        (xx) =>
                            xx.id != 14 &&
                            xx.id != 15 &&
                            xx.id != 16 &&
                            xx.id != 17 &&
                            xx.id != 18 &&
                            xx.id != 20 &&
                            xx.id != 21 &&
                            xx.id != 23 &&
                            xx.id != 24 &&
                            xx.id != 8
                    ).map((x) => {
                        let c = {};
                        c.text = x.value;
                        c.value = { id: x.id, title: x.value };
                        c.checked = false;
                        return c;
                    });
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        AddQuestionDialog() {
            let questionNo = 1;
            if (this.validate()) {
                if (this.questionsList && this.questionsList.length) {
                    if (this.stepOneData && this.stepOneData.selectedSubjects) {
                        this.questions = [];
                        let currentSubjectId =
                            this.stepOneData.selectedSubjects &&
                            this.stepOneData.selectedSubjects[0]
                                ? this.stepOneData.selectedSubjects[0].id
                                : 0;
                        let subIndex = 0;
                        this.stepOneData.selectedSubjects.map((x) => {
                            if (currentSubjectId != x.id) {
                                currentSubjectId = x.id;
                                ++subIndex;
                            }
                            this.questionsList.map((xx) => {
                                for (let k = 0; k < xx.numberOfQuestion; k++) {
                                    this.questions.push({
                                        index: questionNo,
                                        subIndex,
                                        subject: x,
                                        question_text: "",
                                        solution: "",
                                        correct_answer: null,
                                        options: [],
                                        options_abc: [],
                                        options_pqr: [],
                                        hints: [],
                                        questions: [],
                                        startValue: null,
                                        endValue: null,
                                        questionType: xx.questionType,
                                        subtype: null,
                                        correctMarkingSchema:
                                            xx.correctMarkingSchema,
                                        inCorrectMarkingSchema:
                                            xx.inCorrectMarkingSchema || 0,
                                        partialMarking:
                                            xx.questionType.id ===
                                                this.QUE_TYPES
                                                    .MULTIPLE_CORRECT ||
                                            xx.questionType.id ===
                                                this.QUE_TYPES.COMPREHENSION
                                                ? xx.partialMarking
                                                : false,
                                    });
                                    questionNo++;
                                }
                            });
                        });
                    }
                }
                this.setQuestions(this.questions);
                this.persistent = true;
                this.cComponent = "components/coordinator/Questionadd";
                this.modalwidth = "1000px";
                this.status = true;
            }
        },
        validate() {
            let valid = true;
            let count = 0;
            // if (
            //     !this.instructions ||
            //     this.extractContent(this.instructions, true).trim() === ""
            // ) {
            //     this.$toasted.error(`Please enter instructions`, {
            //         icon: "info",
            //     });
            //     return false;
            // }
            const selectedTargetExam = localStorage.getItem("selectedTarget") ? parseInt(localStorage.getItem("selectedTarget")) : null;
            for (let i = 0; i < this.questionsList.length; i++) {
             
                let xx = this.questionsList[i];
                const questionCount = xx.numberOfQuestion ? parseInt(xx.numberOfQuestion) : 0;
                count +=parseInt(xx.numberOfQuestion);
                if (!xx.questionType || !xx.questionType.id) {
                    this.$toasted.error(
                        `Please select question type for question no.${i + 1} `,
                        { icon: "info" }
                    );
                    valid = false;
                    break;
                } else if (!xx.numberOfQuestion || xx.numberOfQuestion < 1) {
                    this.$toasted.error(
                        `Please enter number of question for question type no.${i +
                            1}`,
                        { icon: "info" }
                    );
                    valid = false;
                    break;
                } else if (
                    !xx.correctMarkingSchema ||
                    xx.correctMarkingSchema < 1
                ) {
                    this.$toasted.error(
                        `Please enter valid correct marks for question no.${i +
                            1}`,
                        { icon: "info" }
                    );
                    valid = false;
                    break;
                } else if (
                    (xx.inCorrectMarkingSchema &&
                        xx.inCorrectMarkingSchema > 0) ||
                    !this.isValidPattern(xx.inCorrectMarkingSchema)
                ) {
                    this.$toasted.error(
                        `Please enter valid incorrect marks for question no.${i +
                            1}`,
                        { icon: "info" }
                    );
                    valid = false;
                    break;
                } else if (
                    (xx.inCorrectMarkingSchema &&
                        xx.inCorrectMarkingSchema > 0) ||
                    !this.isValidDecimal(xx.inCorrectMarkingSchema)
                ) {
                    this.$toasted.error(
                        `Upto two decimal places allowed for incorrect marks for question no.${i +
                            1}`,
                        { icon: "info" }
                    );
                    valid = false;
                    break;
                } else if (
                    Math.abs(xx.inCorrectMarkingSchema) >=
                    xx.correctMarkingSchema
                ) {
                    this.$toasted.error(
                        `Correct Marking schema should be greater than mod of Incorrect marking schema for question no.${i +
                            1}`,
                        { icon: "info" }
                    );
                    valid = false;
                    break;
                } else if (
                    !xx.noOfMandatoryQuestions ||
                    parseInt(xx.numberOfQuestion) <
                        parseInt(xx.noOfMandatoryQuestions) ||
                    parseInt(xx.noOfMandatoryQuestions) == 0
                ) {
                    this.$toasted.error(
                        `Please enter valid number of mandatory questions for question no.${i +
                            1}`,
                        { icon: "info" }
                    );
                    valid = false;
                    break;
                }else if(selectedTargetExam === constants.TARGET_EXAMS.EAMCET && xx.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT && questionCount > 80){
 this.$toasted.error(
                        `For the EAMCET exam, the single correct question count cannot exceed 80.`,
                        { icon: "info" }
                    );
                    valid = false;
                }else if(selectedTargetExam === constants.TARGET_EXAMS.JEE_ADVANCED && xx.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT && questionCount > 20){
 this.$toasted.error(
                        `For the JEE Advanced exam, the Single correct question count cannot exceed 20.`,
                        { icon: "info" }
                    );
                    valid = false;
                }else if(selectedTargetExam === constants.TARGET_EXAMS.JEE_ADVANCED && xx.questionType.id !== constants.QUE_TYPES.SINGLE_CORRECT && questionCount > 10){
 this.$toasted.error(
                        `For the JEE Advanced exam, the question count for each type cannot exceed 10.`,
                        { icon: "info" }
                    );
                    valid = false;
                }else if(selectedTargetExam === constants.TARGET_EXAMS.JEE_MAIN && xx.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT && questionCount > 20){
 this.$toasted.error(
                        `For the JEE Main exam, the single correct question count cannot exceed 20.`,
                        { icon: "info" }
                    );
                    valid = false;
                }else if(selectedTargetExam === constants.TARGET_EXAMS.JEE_MAIN &&  ( xx.questionType.id ===  constants.QUE_TYPES.SUBJECTIVEINTEGER ||  xx.questionType.id === constants.QUE_TYPES.SUBJECTIVE) && questionCount > 5){
 this.$toasted.error(
                        `For the JEE Main exam, the Integer/Numerical question count cannot exceed 5.`,
                        { icon: "info" }
                    );
                    valid = false;
                }else if(selectedTargetExam === constants.TARGET_EXAMS.KCET && xx.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT && questionCount > 60){
 this.$toasted.error(
                        `For the KCET exam, the Single correct question count cannot exceed 60.`,
                        { icon: "info" }
                    );
                    valid = false;
                }else if(selectedTargetExam === constants.TARGET_EXAMS.MHCET && xx.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT){
                    // For MHTCET: PCM subjects max 50, Biology max 100
                    // Since questionsList applies to all subjects, we need to check the max limit
                    // If only Biology is selected, allow up to 100, otherwise limit to 50
                    const hasBiologyOnly = this.stepOneData && this.stepOneData.selectedSubjects && 
                        this.stepOneData.selectedSubjects.length === 1 && 
                        this.stepOneData.selectedSubjects[0].id === constants.BIOLOGY_SUBJECT_ID;
                    const maxQuestions = hasBiologyOnly ? 100 : 50;
                    
                    if(questionCount > maxQuestions){
                        this.$toasted.error(
                            `For the MHTCET exam, the Single correct question count cannot exceed ${maxQuestions} ${hasBiologyOnly ? 'for Biology' : 'per subject'}.`,
                            { icon: "info" }
                        );
                        valid = false;
                    }
                }else if(selectedTargetExam === constants.TARGET_EXAMS.BITSAT && xx.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT && questionCount > 40){
                    this.$toasted.error(
                        `For the BITSAT exam, the Single correct question count cannot exceed 40 per subject.`,
                        { icon: "info" }
                    );
                    valid = false;
                }else if(selectedTargetExam === constants.TARGET_EXAMS.VITEEE && xx.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT && questionCount > 40){
                    this.$toasted.error(
                        `For the VITEEE exam, the Single correct question count cannot exceed 40 per subject.`,
                        { icon: "info" }
                    );
                    valid = false;
                }else if(selectedTargetExam === constants.TARGET_EXAMS.SRMJEE && xx.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT && questionCount > 40){
                    this.$toasted.error(
                        `For the SRMJEE exam, the Single correct question count cannot exceed 40 per subject.`,
                        { icon: "info" }
                    );
                    valid = false;
                }else if(selectedTargetExam === constants.TARGET_EXAMS.NEET && xx.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT){
                    const selectedSubjects = this.stepOneData?.selectedSubjects || [];
                    const isBiologySubject = selectedSubjects.some(subject => 
                        subject.id === constants.BIOLOGY_SUBJECT_ID || 
                        subject.code === 'b' || 
                        subject.code === 'z'
                    );
                    const maxQuestions = isBiologySubject ? 90 : 45;
                    
                    if(questionCount > maxQuestions){
                        this.$toasted.error(
                            `For the NEET exam, the Single correct question count cannot exceed ${maxQuestions} for ${isBiologySubject ? 'Botany/Zoology' : 'Physics/Chemistry'}.`,
                            { icon: "info" }
                        );
                        valid = false;
                    }
                }else if(selectedTargetExam === constants.TARGET_EXAMS.OTHERS && xx.questionType.id === constants.QUE_TYPES.SINGLE_CORRECT && questionCount > 50){
 this.$toasted.error(
                        `For the OTHERS exam, the Single correct question count cannot exceed 50.`,
                        { icon: "info" }
                    );
                    valid = false;
                }
            }
          
            return valid;
        },
        isValidDecimal(inCorrectMarkingSchema) {
            let incorrectMarks = (inCorrectMarkingSchema + "").split(".");
            if (incorrectMarks.length == 2) {
                if (incorrectMarks[1].length > 2) {
                    return false;
                }
            }
            return true;
        },
        isValidPattern(num) {
            let regex = /^0$|^-?[1-9]\d*(\.\d+)?$/;
            if (regex.test(num)) {
                return true;
            }
            return false;
        },
        removeType(idx) {        
        this.questionsList.splice(idx, 1);
        },
    },
};
</script>
